import { render, staticRenderFns } from "./UserPreferencesEdit.vue?vue&type=template&id=626c5a5c&"
import script from "./UserPreferencesEdit.vue?vue&type=script&lang=js&"
export * from "./UserPreferencesEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserPreferencesEdit.vue?vue&type=style&index=0&id=626c5a5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports